import React from "react";
import ReactPlayer from "react-player";


class IdoaVideoPlayer extends React.Component {
    render() {
        const {contentState, entityKey} = this.props;
        const data = contentState.getEntity(entityKey).getData();
        const config = { file: {
            attributes: {
                controlsList: 'nodownload'
            }
        }};
        return (<ReactPlayer className={'img-fluid'} url={data.src} controls={true} config={config}/>);
    }
}

export default () => {
    return {
        decorators: [
            {
                strategy: (contentBlock, callback, contentState) => {
                    contentBlock.findEntityRanges(
                        (character) => {
                            const entityKey = character.getEntity();
                            return ( entityKey != null && contentState.getEntity(entityKey).getType() === 'IDOA_VIDEO' );
                        },
                        callback,
                    );
                },
                editable: false,
                component: IdoaVideoPlayer,
            }
        ]
    };
};
